(function () {
  'use strict';
  function formURL(current, action, entries) {
    var url = new URL(action, current);
    var previous = new URL(current);
    if (url.origin !== previous.origin) return url;
    previous.searchParams.forEach(function (value, key) {
      if (!key.startsWith('filter.') && !['page', 'q', 'type', 'sort_by', 'options[prefix]'].includes(key)) {
        url.searchParams.append(key, value);
      }
    });
    entries.forEach(function (entry) {
      if (entry[1] !== '' && entry[0] !== 'page') url.searchParams.append(entry[0], entry[1]);
    });
    return url;
  }
  async function pricePage(options) {
    var pages = new Array(options.pages);
    var next = 1;
    async function worker() {
      while (next <= options.pages) {
        var page = next++;
        pages[page - 1] = await options.getPage(page);
      }
    }
    await Promise.all(Array.from({ length: Math.min(3, options.pages) }, worker));
    var cards = pages.flat();
    if (cards.length !== options.total || new Set(cards.map(function (card) { return card.id; })).size !== cards.length) {
      throw new Error('Results changed while sorting');
    }
    cards.forEach(function (card) { if (!Number.isFinite(card.price)) throw new Error('Missing price'); });
    cards.sort(function (a, b) { return (a.price - b.price) * options.direction; });
    return cards.slice((options.page - 1) * options.size, options.page * options.size);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { formURL: formURL, pricePage: pricePage };
  if (typeof document === 'undefined') return;

  function initializePrices() {
  var grid = document.querySelector('[data-price-grid]');
  var sort = grid && grid.dataset.sort;
  var hasVariantFilter = Array.from(new URL(window.location.href).searchParams.keys()).some(function (key) { return key.startsWith('filter.v.'); });
  if (grid && hasVariantFilter && (sort === 'price-ascending' || sort === 'price-descending')) {
    var status = document.querySelector('[data-price-status]');
    var retry = status.querySelector('button');
    var message = status.querySelector('[role="status"]');
    var originalCards = Array.from(grid.children);
    function readCards(container) {
      return Array.from(container.querySelectorAll('[data-product-id]')).map(function (node) {
        return { id: node.dataset.productId, price: Number(node.dataset.cardPrice), node: node };
      });
    }
    async function sortPrices() {
      grid.setAttribute('aria-busy', 'true');
      status.hidden = false;
      retry.hidden = true;
      message.textContent = status.dataset.loading;
      try {
        var cards = await pricePage({
          pages: Number(grid.dataset.pages), page: Number(grid.dataset.page), size: Number(grid.dataset.pageSize),
          total: Number(grid.dataset.total), direction: sort === 'price-descending' ? -1 : 1,
          getPage: async function (page) {
            if (page === Number(grid.dataset.page)) return readCards(grid);
            var url = new URL(window.location.href);
            url.searchParams.set('page', page);
            url.searchParams.set('section_id', grid.dataset.section);
            var controller = new AbortController();
            var timeout = setTimeout(function () { controller.abort(); }, 15000);
            try {
              var response = await fetch(url, { signal: controller.signal });
              if (!response.ok) throw new Error('Unable to load results');
              var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              var other = doc.querySelector('[data-price-grid]');
              if (!other || other.dataset.total !== grid.dataset.total || other.dataset.page !== String(page)) throw new Error('Incomplete results');
              return readCards(other);
            } finally { clearTimeout(timeout); }
          }
        });
        grid.replaceChildren.apply(grid, cards.map(function (card) { return card.node; }));
        grid.dataset.priceSorted = 'true';
        status.hidden = true;
      } catch (_) {
        grid.replaceChildren.apply(grid, originalCards);
        message.textContent = status.dataset.error;
        retry.hidden = false;
      } finally { grid.removeAttribute('aria-busy'); }
    }
    retry.addEventListener('click', sortPrices);
    sortPrices();
  }

  }

  function rememberFocus() {
    try { sessionStorage.setItem('cg-discovery-focus', 'results'); } catch (_) { /* Storage is optional. */ }
  }
  function validatePrice(form) {
    var min = form.querySelector('[name="filter.v.price.gte"]');
    var max = form.querySelector('[name="filter.v.price.lte"]');
    if (!min || !max) return true;
    var invalid = min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value);
    max.setCustomValidity(invalid ? form.dataset.priceRangeError : '');
    return !invalid;
  }
  document.querySelectorAll('[data-discovery-form]').forEach(function (form) {
    form.addEventListener('input', function () { validatePrice(form); });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!validatePrice(form) || !form.checkValidity()) { form.reportValidity(); return; }
      rememberFocus();
      window.location.assign(formURL(window.location.href, form.action, Array.from(new FormData(form).entries())).href);
    });
  });
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () { select.form.requestSubmit(); });
    select.form.setAttribute('data-auto-sort', '');
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-discovery-form]').forEach(function (form) {
      form.reset();
      validatePrice(form);
    });
  });
  document.querySelectorAll('[data-discovery-link]').forEach(function (link) {
    var url = new URL(link.href);
    url.searchParams.delete('page');
    ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
      var value = new URL(window.location.href).searchParams.get(key);
      if (value && !url.searchParams.has(key)) url.searchParams.set(key, value);
    });
    link.href = url.href;
    link.addEventListener('click', rememberFocus);
  });

  var desktop = window.matchMedia('(min-width: 990px)');
  var facets = document.querySelectorAll('[data-discovery-facet]');
  facets.forEach(function (facet) {
    facet.addEventListener('toggle', function () {
      if (facet.open && desktop.matches) {
        facets.forEach(function (other) { if (other !== facet) other.open = false; });
      }
    });
    facet.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && facet.open) {
        facet.open = false;
        facet.querySelector('summary').focus();
      }
    });
  });
  document.addEventListener('click', function (event) {
    if (desktop.matches) facets.forEach(function (facet) { if (!facet.contains(event.target)) facet.open = false; });
  });
  var panels = document.querySelectorAll('[data-side-panel]');
  function sync() { panels.forEach(function (panel) { panel.open = desktop.matches; }); }
  sync();
  if (desktop.addEventListener) desktop.addEventListener('change', sync);
  else if (desktop.addListener) desktop.addListener(sync);
  try {
    if (sessionStorage.getItem('cg-discovery-focus') === 'results') {
      sessionStorage.removeItem('cg-discovery-focus');
      var results = document.querySelector('[data-discovery-results]');
      if (results) results.focus({ preventScroll: true });
    }
  } catch (_) { /* Native navigation and links remain available. */ }
  initializePrices();
  document.addEventListener('cg:discovery-updated', initializePrices);
})();
